"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _member = require("@/api/member/member");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      isShowTime: false,
      gradeInvalidTime: '',
      ruleForm: {
        memberId: '',
        duration: '',
        reason: ''
      },
      rules: {
        reason: [{
          required: true,
          message: '请输入备注',
          trigger: 'blur'
        }],
        duration: [{
          required: true,
          message: '请选择续期时长',
          trigger: 'change'
        }]
      }
    };
  },
  methods: {
    open: function open(gradeInvalidTime, memberId) {
      this.gradeInvalidTime = gradeInvalidTime;
      this.ruleForm.memberId = memberId;
      this.isShowTime = true;
    },
    TimeClose: function TimeClose() {
      this.isShowTime = false;
      this.resetForm('ruleForm');
    },
    submitForm: function submitForm(formName) {
      var _this = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this.$confirm('是否确认此操作?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            _this.renewMemberGradeApi();
          });
        } else {
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    renewMemberGradeApi: function () {
      var _renewMemberGradeApi = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var params, res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              params = (0, _objectSpread2.default)({}, this.ruleForm);
              _context.n = 1;
              return (0, _member.renewMemberGrade)(params);
            case 1:
              res = _context.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '操作成功'
                });
                this.TimeClose();
                this.$emit('timeRefresh');
              } else {
                this.$notify.success({
                  title: '温馨提示',
                  message: '操作失败'
                });
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function renewMemberGradeApi() {
        return _renewMemberGradeApi.apply(this, arguments);
      }
      return renewMemberGradeApi;
    }()
  }
};